import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { DialogType, MediDialogComponent } from '../medi-dialog/medi-dialog.component';
import { Observable } from 'rxjs';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import { Router } from '@angular/router';
import { OroService } from '../oroservice';

// Password-change form model bound in user-data.component.html and posted via
// OroService.changePassword.
interface UserDaten {
    AltesKenntwort?: string;
    NeuesKenntwort?: string;
    NeuesKenntwort2?: string;
}

@Component({
    selector: 'app-user-data',
    templateUrl: './user-data.component.html',
    styleUrls: ['./user-data.component.scss'],
    standalone: false
})
export class UserDataComponent implements OnInit {
    userdaten: UserDaten = {};

    isValid = false;

    IsNewPassword = false;
    IsNewEmail = false;
    NeueEmail: string;

    OldData: string;

    constructor(public oroservice: OroService, private _router: Router, public dialog: MatDialog, private cdref: ChangeDetectorRef, private sanitizer: DomSanitizer, private snackBar: MatSnackBar, private translate: TranslateService) { }

    ngOnInit() {
        this.refresh();
    }

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    @HostListener('window:beforeunload')
    canDeactivate(): Observable<boolean> | boolean {
        const NewData = JSON.stringify(this.userdaten).replace(/null/g, "\"\"");

        return (this.OldData.localeCompare(NewData) === 0);
	}

    refresh() {
        //this.oroservice.getStammdaten().then((object) => {
        //    this.userdaten = object;
            this.isValid = true;

        //    this.OldData = JSON.stringify(this.userdaten).replace(/null/g,"\"\"");
        //});
    }

    SaveSettings() {
        this.oroservice.changePassword(this.userdaten).then(() => {
            this.snackBar.open(this.translate.instant('Login.PasswordErfolgreichInfo'), undefined, {
                duration: 5000,
                horizontalPosition: 'center',
                verticalPosition: 'top'
            });

            this.userdaten.AltesKenntwort = '';
            this.userdaten.NeuesKenntwort = '';
            this.userdaten.NeuesKenntwort2 = '';

            this.IsNewPassword = false;
        });
    }

    GetNewEmail() {
        this.oroservice.getnewEmail(this.NeueEmail).then((object) => {
            const message = object?.message ?? 'Eine E-Mail mit Aktivierungslink wurde an Ihre neue E-Mail geschickt. Bis zur Aktivierung ist Ihre alte E-Mail aktiv';
            this.snackBar.open(message, undefined, {
                duration: 5000,
                horizontalPosition: 'center',
                verticalPosition: 'top'
            });

            this.oroservice.getKundenInfo().then(() => {
                this.NeueEmail = this.oroservice.kundeninfo.Email;
            });
        });
    }

    resetisnewpassword() {
        if (this.IsNewPassword) {
            this.IsNewEmail = false;
        } else {
            this.userdaten.AltesKenntwort = "";
            this.userdaten.NeuesKenntwort = "";
            this.userdaten.NeuesKenntwort2 = "";
        }
    }

    resetisnewemail() {
        if (this.IsNewEmail) {
            this.IsNewPassword = false;
            this.NeueEmail = this.oroservice.kundeninfo.Email;
        } else {
            this.NeueEmail = this.oroservice.kundeninfo.Email;
        }
    }

    validateemail(email: string): boolean {
        const regex = /^((?!\.)[\w\-_.]*[^.])(@[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])*[a-zA-Z0-9])(\.[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])*[a-zA-Z0-9])+$/;
        return regex.test(email);
    }

    openDialog(paramWidth: string, paramTitle: string, paramContent: string, paramYes: string, paramNo: string, paramType: DialogType = DialogType.None): Observable<boolean> {
        const dialogRef = this.dialog.open(MediDialogComponent, {
            width: paramWidth,
            data: { title: paramTitle, content: paramContent, yes: paramYes, no: paramNo, type: paramType }
        });

        return dialogRef.afterClosed();
    }

    public canSubmit(): boolean {
        if (this.IsNewPassword) {
            if (!this.userdaten.AltesKenntwort || !this.userdaten.NeuesKenntwort || !this.userdaten.NeuesKenntwort2) {
                return false;
            }
            if (this.userdaten.NeuesKenntwort !== this.userdaten.NeuesKenntwort2) {
                return false;
            }
            return true;
        }

        if (this.IsNewEmail) {
            return !!this.NeueEmail;
        }

        return false;
    }
}
